import React from 'react';

const SectionTitle = ({
  label,
  title,
  description,
  align = 'center',
  light = false
}) => {
  const alignmentClass = {
    left: 'text-left',
    center: 'text-center mx-auto',
    right: 'text-right ml-auto'
  }[align];

  return (
    <div className={`max-w-3xl mb-12 lg:mb-16 ${alignmentClass}`}>
      {label && (
        <span className={`inline-block text-sm font-medium tracking-widest uppercase mb-4 ${
          light ? 'text-sky-400' : 'text-sky-500'
        }`}>
          {label}
        </span>
      )}
      <h2 className={`text-3xl md:text-4xl lg:text-5xl font-light leading-tight mb-4 ${
        light ? 'text-white' : 'text-gray-900'
      }`}>
        {title}
      </h2>
      {description && (
        <p className={`text-lg font-light leading-relaxed ${
          light ? 'text-gray-300' : 'text-gray-600'
        }`}>
          {description}
        </p>
      )}
    </div>
  );
};

export default SectionTitle;
